import { fork, all } from 'redux-saga/effects'

import runRedirectSaga from './runRedirectSaga'

export default function* routerSaga() {
  yield all([fork(runRedirectSaga)])
}
